<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<ng-container *ngIf="isScreenSmall" class="!font-inter">
    <div *ngIf="loggedIn">
        <fuse-vertical-navigation class="print:hidden text-primary" [mode]="'over'" [name]="'mainNavigation'" 
            [navigation]="navigation.default" [opened]="false">
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationHeader>
                <!-- Logo -->
                <div class="flex flex-row items-center justify-center w-full py-6 px-8 hover:cursor-pointer" [routerLink]="['/']">
                    <img class="w-24 items-center rounded-xl" src="assets/images/logo/logo.png" alt="Logo image" loading="lazy">                  
                </div>
            </ng-container>
            <ng-container fuseVerticalNavigationFooter>
                <!-- Log in-out -->
                 <div class="w-full flex justify-center bg-[#EBEBEB]">
                    <button mat-button class="text-black bg-primary mx-2 my-4 px-7 py-6 font-inter-bold text-xl crisp-button" mat-flat-button mat-flat-button (click)="signOut()">
                        Log Out
                    </button>
                 </div>
            </ng-container>
        </fuse-vertical-navigation>
    </div>

    <div *ngIf="!loggedIn"  class="!font-inter">
        <fuse-vertical-navigation class="" [mode]="'over'" [name]="'mainNavigation'" 
            [navigation]="navigation.default" [opened]="false">
            <!-- Navigation header hook -->
            <ng-container fuseVerticalNavigationHeader>
                <!-- Logo -->
                <div class="flex flex-row items-center justify-center w-full py-6 px-8 hover:cursor-pointer" [routerLink]="['/']">
                    <img class="w-24 items-center rounded-xl" src="assets/images/logo/logo.png" alt="Logo image" loading="lazy">                  
                </div>
            </ng-container>
            <ng-container fuseVerticalNavigationFooter>
                <!-- Log in-out -->
                 <div class="w-full flex justify-center">
                     <button mat-button class="text-white bg-primary mx-2 my-4 px-7 py-6 font-inter-bold text-xl crisp-button" mat-flat-button [routerLink]="['/sign-in']" >
                         Log In/Register
                     </button>
                 </div>
            </ng-container>
        </fuse-vertical-navigation>
    </div>
</ng-container>
<!-- Wrapper -->
<div class="flex-col flex-auto items-center w-full min-w-0 dark:bg-card !font-inter" >
    <!-- Header -->
    <div
        class="sticky  top-0 flex flex-col flex-0 justify-center w-full overflow-hidden z-49 shadow dark:shadow-none print:hidden ">
        <!-- Navigation toggle button -->
        <ng-container *ngIf="isScreenSmall">
            <div
                class="w-full flex flex-row justify-between items-center px-4 py-2  bg-gradient-to-r from-white to-neutral-100">
                <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                    <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                </button>
                <div class="flex flex-row space-x-8">
                    <button *ngIf="showCart()" class="flex flex-row items-center rounded-full py-1 text-center"
                        [routerLink]="['/cart']" (click)="signUpRequired()">
                        <mat-icon class="icon-size-5 text-primary-500 text-center"
                            svgIcon="heroicons_solid:shopping-cart">
                        </mat-icon>
                    </button>
                    <button *ngIf="!loggedIn" class="flex flex-row items-center rounded-full py-1"
                        [routerLink]="['/sign-in']">
                        <p class="font-semibold text-lg">
                            Sign in
                        </p>
                    </button>
                    <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="hasToken"
                        class="background-button-white rounded-full">
                        <mat-icon>account_circle</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" class="-ml-24">
                        <button mat-menu-item [routerLink]="'/dashboard'">
                            <mat-icon>dashboard</mat-icon>
                            <span>Dashboard</span>
                        </button>
                        <button mat-menu-item [routerLink]="'/dashboard/profile'">
                            <mat-icon>manage_accounts</mat-icon>
                            <span>Profile</span>
                        </button>
                        <button *ngIf="hasToken" mat-menu-item (click)="logout()">
                            <mat-icon>logout</mat-icon>
                            <span>Logout</span>
                        </button>
                    </mat-menu>
                </div>
            </div>
        </ng-container>
        <!-- Menu bar -->
        <ng-container *ngIf="!isScreenSmall">
            <div
                class="flex flex-auto  bg-gradient-to-r from-neutral-800 via-neutral-900 to-neutral-950  shadow-lg  p-4 !font-inter">
                <div class="items-center w-full max-w-full px-12 flex flex-row justify-between">
                    <div class="flex flex-row items-center space-x-20">
                        <img class="hover:cursor-pointer w-15" src="assets/kako-logo.png" alt="" (click)="goHome()">
                        
                        <fuse-horizontal-navigation class="flex space-x-4" [name]="'mainNavigation'"
                            [navigation]="hasToken ? navigation.horizontalLoggedIn : navigation.horizontal">
                        </fuse-horizontal-navigation>
                    </div>
                    
                    <div class="flex flex-row items-center ">
                        <mat-menu #menu="matMenu" class="-ml-24">
                            <button *ngIf="hasToken" mat-menu-item [routerLink]="'/cart'">
                                <mat-icon class="   text-center"
                                    svgIcon="heroicons_solid:shopping-cart">
                                </mat-icon>
                                <span>Cart</span>
                            </button>
                            <button mat-menu-item [routerLink]="'/dashboard'">
                                <mat-icon>dashboard</mat-icon>
                                <span>Dashboard</span>
                            </button>
                            <button mat-menu-item [routerLink]="'/dashboard/profile'">
                                <mat-icon>manage_accounts</mat-icon>
                                <span>Profile</span>
                            </button>
                            <button *ngIf="hasToken" mat-menu-item (click)="logout()">
                                <mat-icon>logout</mat-icon>
                                <span>Logout</span>
                            </button>
                        </mat-menu>
                        <!-- Trigger Button -->
                        <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="hasToken"
                            class="background-button-white rounded-full text-white ">
                            <mat-icon class="text-white">account_circle</mat-icon>
                        </button>

                        <div class="flex flex-row items-center space-x-12">
                           
                            <button mat-flat-button (click)="signIn()" *ngIf="!hasToken"
                                class="text-white rounded-full bg-accent">
                                <p class="font-semibold text-lg">
                                    Sign in
                                </p>
                            </button>
                        </div>


                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Content -->
    <div class="flex-auto justify-center w-full overflow-hidden">
        <router-outlet *ngIf="true"></router-outlet>
    </div>
    <app-footer (focusInput)="focusOnSearch()"></app-footer>
</div>


<ng-template #inActivityDialog>
    <div>
        <div class="flex flex-col justify-center items-center">
            <mat-icon class="text-primary icon-size-10" svgIcon="heroicons_outline:cursor-arrow-rays"></mat-icon>
            <h1 class="font-extrabold text-xl py-6">
                Inactivity detected.
            </h1>
        </div>
        <h2 class="text-sm text-center pb-6">
            You will be signed out in <span class="font-bold">{{countDownValue}}</span> seconds.
        </h2>

        <div class="flex justify-end">
            <button class="flex flex-row justify-center items-center" [color]="'primary'" type="button"
                (click)="resetInactivityTimer()" mat-flat-button>
                Don't sign me out!
            </button>
        </div>
    </div>
</ng-template>